import Card from "components/Cards/Card";
import React from "react";

const ProjectTabDescription = ({ description, t = (d) => d }) => {
  return (
    <Card maxHeight="1000px" classes="mt-5 pb-6 overflowY-auto">
      <div className="p-6">
        <h2 className="fs-22 fw-600 mb-4">{t("Project Description")}</h2>
        {description ? (
          <div
            className="fs-16 c-darkgray"
            dangerouslySetInnerHTML={{ __html: description }}
          />
        ) : (
          <div className="fs-16 c-gray">
            {t("This project does not have a description.")}
          </div>
        )}
      </div>
    </Card>
  );
};

export default ProjectTabDescription;
